
define('ldsh!common/templates/trial_expiration_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container ed-modal-expire">\n\n  <!-- header -->\n  <div class="ed-opt-toolbar ed-modal-header">\n    <h3 data-i18n="trial.title" class="ed-modal-title"></h3>\n  </div>\n\n  <!-- contenido -->\n  <div class="ed-opt-content ed-modal-content">\n    <p data-i18n="trial.info"></p>\n    <p data-i18n="trial.help"></p>\n    <p class="ed-actions">\n      <a data-i18n="trial.upgrade" href=' +
((__t = (paymentsUrl + "/account/products?company_id=" + companyId )) == null ? '' : __t) +
'\n        class="ed-btn ed-btn-sec"></a>\n      <a data-i18n="trial.accept" class="ed-btn-link js-accept" href="#"></a>\n    </p>\n  </div>\n\n</div>';

}
return __p
};});

